import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import GenericUpper from '../../components/generic-upper';
import api from '../../services/api';
import Button from '../../components/button/button_v2';

import { store } from "react-notifications-component";
import identifyErrorMenssage from "../../services/identifyErrorMenssage";

import logomini from '../../assets/logo-mini.png';
import logobling from '../../assets/logos/bling.png';
import logotiny from '../../assets/logos/tiny.png';
import logoomie from '../../assets/logos/omie.png';
import logocontaazul from '../../assets/logos/contaazul.png';
import logototvs from '../../assets/logos/parceiros/totvs.svg';
import logomm from '../../assets/logos/parceiros/mm.png';
import logosantri from '../../assets/logos/parceiros/santri.png';
import logoseculos from '../../assets/logos/parceiros/seculos.png';
import logoproton from '../../assets/logos/parceiros/proton.png';
import logosiac from '../../assets/logos/parceiros/siac.png';

import { theme } from '../../styles/theme';

import {
    IntegracaoContainer, SecTit, SecSub, Grid, Card, CardTop, LogoBox,
    Tags, Tag, CardTitle, CardDesc, Recursos, RecursoItem, ManualLink, Acoes,
    VoltarLink
} from './styles';
import AddIntegracao from './add';

const { colors } = theme;

const CheckIcon = () => (
    <svg width="12" height="12" viewBox="0 0 14 14" fill="none">
        <path d="M2 7.5L5.5 11 12 3.5" stroke={colors.green.Verde_AgroReceita} strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const DocIcon = () => (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none">
        <path d="M2.5 3.5A1.5 1.5 0 014 2h4v11H4a1.5 1.5 0 00-1.5 1.5V3.5zM13.5 3.5A1.5 1.5 0 0012 2H8v11h4a1.5 1.5 0 011.5 1.5V3.5z" stroke="currentColor" strokeWidth="1.4" strokeLinejoin="round" />
    </svg>
);

const PARCEIROS = [
    {
        logo: logototvs,
        title: 'Protheus (TOTVS)',
        desc: 'Integração dedicada com o <b>ERP Protheus</b>: emita receitas agronômicas diretamente do fluxo de faturamento do Protheus, com sincronização de clientes e produtos.',
        recursos: ['Emissão integrada ao faturamento', 'Implantação assistida pelo nosso time'],
        acessarUrl: null
    },
    {
        logo: logomm,
        title: 'M&M Informática',
        desc: 'Sistemas e aplicações sob medida para o mercado do <b>agronegócio, atacado e varejo</b>, com emissão de receitas agronômicas integrada via API AgroReceita.',
        recursos: ['Receita emitida junto à venda no ERP', 'Integração nativa, basta ativar'],
        acessarUrl: 'https://mminfo.me'
    },
    {
        logo: logosantri,
        title: 'Santri Sistemas',
        desc: 'Soluções completas para <b>infraestrutura e segurança tecnológica</b> do seu negócio, com receituário agronômico integrado via API AgroReceita.',
        recursos: ['Receita emitida junto à venda no ERP', 'Integração nativa, basta ativar'],
        acessarUrl: 'https://www.santri.com.br'
    },
    {
        logo: logoseculos,
        title: 'Séculos Sistemas',
        desc: 'Software de <b>gestão empresarial completo e integrado</b> para a rotina do seu negócio, com receituário agronômico integrado via API AgroReceita.',
        recursos: ['Receita emitida junto à venda no ERP', 'Integração nativa, basta ativar'],
        acessarUrl: 'https://seculos.com.br'
    },
    {
        logo: logoproton,
        title: 'Próton Sistemas',
        desc: 'Software <b>escalável</b> projetado para atender às necessidades de qualquer empresa, com receituário agronômico integrado via API AgroReceita.',
        recursos: ['Receita emitida junto à venda no ERP', 'Integração nativa, basta ativar'],
        acessarUrl: 'https://www.protonsistemas.com.br'
    },
    {
        logo: logosiac,
        title: 'SIAC Sistemas',
        desc: 'Soluções de gestão para o mercado <b>varejista, atacadista, industrial e prestadoras de serviço</b>, com receituário agronômico integrado via API AgroReceita.',
        recursos: ['Receita emitida junto à venda no ERP', 'Integração nativa, basta ativar'],
        acessarUrl: 'https://www.siacsistemas.com.br'
    }
];

const PLUGA = [
    {
        framework: 'Bling', logo: logobling,
        title: 'Bling',
        desc: 'Conecte o <b>Bling ERP</b> ao AgroReceita através do <b>Pluga</b> e envie as informações do receituário agronômico para o seu ERP — integração simples e rápida, sem programar nada.',
        manualUrl: 'https://pluga.co/ferramentas/pluga-webhooks/integracao/bling/'
    },
    {
        framework: 'Tiny', logo: logotiny,
        title: 'Tiny ERP',
        desc: 'Conecte o <b>Tiny ERP</b> (Olist) ao AgroReceita através do <b>Pluga</b> e envie as informações do receituário agronômico para o seu ERP — integração simples e rápida, sem programar nada.',
        manualUrl: 'https://pluga.co/ferramentas/pluga-webhooks/integracao/tinyerp/'
    },
    {
        framework: 'Omie', logo: logoomie,
        title: 'Omie',
        desc: 'Conecte o <b>Omie ERP</b> ao AgroReceita através do <b>Pluga</b> e envie as informações do receituário agronômico para o seu ERP — integração simples e rápida, sem programar nada.',
        manualUrl: 'https://pluga.co/ferramentas/pluga-webhooks/integracao/omie/'
    },
    {
        framework: 'Conta Azul', logo: logocontaazul,
        title: 'Conta Azul',
        desc: 'Conecte o <b>Conta Azul</b> ao AgroReceita através do <b>Pluga</b> e envie as informações do receituário agronômico para o seu financeiro — integração simples e rápida, sem programar nada.',
        manualUrl: 'https://pluga.co/ferramentas/pluga-webhooks/integracao/conta-azul-financeiro/'
    }
];

const WHATSAPP_ESPECIALISTA = 'https://api.whatsapp.com/send/?phone=5515996577718';
const WHATSAPP_VENDAS = 'https://api.whatsapp.com/send?phone=5515981657739';

const isFrameworkConectado = (integrations, frameworkName, pluga) => {
    return integrations.some((i) => (
        i.status === 1 &&
        i.framework?.framework === frameworkName &&
        (i.framework?.integration_type?.id === 2) === pluga
    ));
};

const Integracao = ({ ...props }) => {

    const [integrations, setIntegrations] = useState([]);
    const [criar, setCriar] = useState(false);
    const [preselectFramework, setPreselectFramework] = useState(null);

    const getIntegrations = async () => {
        try {
            const response = await api.get('/integracao');

            if (response) {
                setIntegrations(response.data.data);
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error, "ERRO-670 Não foi possível carregar as integrações - Tente novamente, se o erro persistir acione o suporte."),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const criarIntegracao = (framework) => {
        setPreselectFramework(framework || null);
        setCriar(true);
    }

    const voltarCatalogo = () => {
        setCriar(false);
        setPreselectFramework(null);
    }

    const postIntegration = async (e) => {
        try {
            const response = await api.post(`/integracao`, e);

            if (response) {
                store.addNotification({
                    title: "Sucesso!",
                    message: `Integração configurada com sucesso!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });

                setTimeout(() => {
                    getIntegrations();
                    voltarCatalogo();
                }, 500);
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const loadIntegrations = () => {
        getIntegrations();
    }

    useEffect(() => {
        loadIntegrations();
    }, []);

    const agroReceitaConectado = isFrameworkConectado(integrations, 'AgroReceita', false);

    return (
        <>
            <GenericUpper
                title="Integração"
                subtitle="Integre o AgroReceita com o seu sistema."
            />

            <IntegracaoContainer>
                {criar ? (
                    <>
                        <VoltarLink onClick={() => voltarCatalogo()}>← Voltar para Integração</VoltarLink>
                        <AddIntegracao preselectFramework={preselectFramework} save={(e) => postIntegration(e)} onCancel={() => voltarCatalogo()} />
                    </>
                ) : (
                    <>
                        <SecTit style={{ marginTop: 0 }}>API e Webhooks</SecTit>
                        <SecSub>Conecte o seu sistema diretamente ao AgroReceita.</SecSub>
                        <Grid>
                            <Card>
                                <CardTop>
                                    <LogoBox><img src={logomini} alt="Logo AgroReceita" /></LogoBox>
                                    <Tags>
                                        <Tag variant="nativa">Nativa</Tag>
                                    </Tags>
                                </CardTop>
                                <CardTitle>API AgroReceita</CardTitle>
                                <CardDesc dangerouslySetInnerHTML={{ __html: 'Integração via <b>API REST</b> para conectar o AgroReceita ao seu ERP: retorna os dados de forma rápida e segura, facilitando a emissão do receituário agronômico, com <b>banco de dados das bulas dos defensivos atualizado em tempo real</b>, conforme alterações do MAPA.' }} />
                                <Recursos>
                                    <RecursoItem><CheckIcon />Conteúdo no formato JSON, na sua linguagem favorita</RecursoItem>
                                    <RecursoItem><CheckIcon />Envio de dados às Defesas Agropecuárias</RecursoItem>
                                    <RecursoItem><CheckIcon />Documentação de integração e suporte personalizado</RecursoItem>
                                </Recursos>
                                <ManualLink href="https://doc.agroreceita.com.br/" target="_blank" rel="noopener"><DocIcon />Documentação da API</ManualLink>
                                <Acoes>
                                    {agroReceitaConectado ? (
                                        <Button
                                            width='100%'
                                            height='44px'
                                            value='ENTRAR EM CONTATO'
                                            outline={false}
                                            onClick={() => window.open(WHATSAPP_VENDAS, '_blank', 'noopener')}
                                        />
                                    ) : (
                                        <Button
                                            width='100%'
                                            height='44px'
                                            value='CRIAR INTEGRAÇÃO'
                                            imagePlus={true}
                                            outline={false}
                                            onClick={() => criarIntegracao('AgroReceita')}
                                        />
                                    )}
                                </Acoes>
                            </Card>

                            <Card>
                                <CardTop>
                                    <LogoBox>
                                        <svg width="22" height="22" viewBox="0 0 16 16" fill="none">
                                            <path d="M9.5 2L4 8.5h3L6.5 14 12 7.5H9L9.5 2z" stroke={colors.green.Verde_AgroReceita} strokeWidth="1.4" strokeLinejoin="round" />
                                        </svg>
                                    </LogoBox>
                                    <Tags>
                                        <Tag variant="nativa">Nativa</Tag>
                                        {agroReceitaConectado && <Tag variant="conectado">Conectado</Tag>}
                                    </Tags>
                                </CardTop>
                                <CardTitle>Webhook AgroReceita</CardTitle>
                                <CardDesc dangerouslySetInnerHTML={{ __html: 'O AgroReceita <b>envia uma mensagem automática</b> ao seu sistema quando um evento ocorre — integração em tempo real, mantendo as informações sincronizadas, sem solicitações constantes.' }} />
                                <Recursos>
                                    <RecursoItem><CheckIcon />Receitas agronômicas emitidas</RecursoItem>
                                    <RecursoItem><CheckIcon />Cadastros de fazenda</RecursoItem>
                                    <RecursoItem><CheckIcon />Cancelamento de receituários</RecursoItem>
                                </Recursos>
                                <ManualLink href="https://agroreceita.com.br/como-integrar/" target="_blank" rel="noopener"><DocIcon />Manual do Webhook AgroReceita</ManualLink>
                                <Acoes>
                                    {agroReceitaConectado ? (
                                        <Button
                                            width='100%'
                                            height='44px'
                                            value='CONFIGURAÇÕES'
                                            outline={true}
                                            color={colors.gray.Cinza_2}
                                            onClick={() => props.history.push('/integracao-webhook')}
                                        />
                                    ) : (
                                        <Button
                                            width='100%'
                                            height='44px'
                                            value='CONFIGURAR WEBHOOK'
                                            imagePlus={true}
                                            outline={false}
                                            onClick={() => props.history.push('/integracao-webhook')}
                                        />
                                    )}
                                </Acoes>
                            </Card>
                        </Grid>

                        <SecTit>Parceiros já integrados</SecTit>
                        <SecSub>Sistemas que já possuem integração pronta com o AgroReceita — basta ativar.</SecSub>
                        <Grid>
                            {PARCEIROS.map((p) => (
                                <Card key={p.title}>
                                    <CardTop>
                                        <LogoBox><img src={p.logo} alt={`Logo ${p.title}`} /></LogoBox>
                                    </CardTop>
                                    <CardTitle>{p.title}</CardTitle>
                                    <CardDesc dangerouslySetInnerHTML={{ __html: p.desc }} />
                                    <Recursos>
                                        {p.recursos.map((r) => (<RecursoItem key={r}><CheckIcon />{r}</RecursoItem>))}
                                    </Recursos>
                                    <Acoes>
                                        <Button
                                            width='100%'
                                            height='44px'
                                            value='FALAR COM ESPECIALISTA'
                                            outline={false}
                                            onClick={() => window.open(WHATSAPP_ESPECIALISTA, '_blank', 'noopener')}
                                        />
                                        {p.acessarUrl && (
                                            <Button
                                                width='100%'
                                                height='44px'
                                                value='ACESSAR PARCEIRO'
                                                outline={true}
                                                color={colors.gray.Cinza_2}
                                                onClick={() => window.open(p.acessarUrl, '_blank', 'noopener')}
                                            />
                                        )}
                                    </Acoes>
                                </Card>
                            ))}
                        </Grid>

                        <SecTit>Conexões via Pluga</SecTit>
                        <SecSub>Integrações sem código através da plataforma Pluga — conecte seu ERP em poucos cliques.</SecSub>
                        <Grid>
                            {PLUGA.map((p) => (
                                <Card key={p.framework}>
                                    <CardTop>
                                        <LogoBox><img src={p.logo} alt={`Logo ${p.title}`} /></LogoBox>
                                        <Tags>
                                            <Tag variant="pluga">Via Pluga</Tag>
                                            {isFrameworkConectado(integrations, p.framework, true) && (
                                                <Tag variant="conectado">Conectado</Tag>
                                            )}
                                        </Tags>
                                    </CardTop>
                                    <CardTitle>{p.title}</CardTitle>
                                    <CardDesc dangerouslySetInnerHTML={{ __html: p.desc }} />
                                    <Recursos>
                                        <RecursoItem><CheckIcon />Receitas emitidas, fazendas e cancelamentos</RecursoItem>
                                        <RecursoItem><CheckIcon />Configuração em poucos cliques, sem código</RecursoItem>
                                    </Recursos>
                                    <ManualLink href={p.manualUrl} target="_blank" rel="noopener"><DocIcon />Manual da integração {p.title} + AgroReceita</ManualLink>
                                    <Acoes>
                                        {isFrameworkConectado(integrations, p.framework, true) ? (
                                            <Button
                                                width='100%'
                                                height='44px'
                                                value='CONFIGURAÇÕES'
                                                outline={true}
                                                color={colors.gray.Cinza_2}
                                                onClick={() => props.history.push('/integracao-webhook')}
                                            />
                                        ) : (
                                            <Button
                                                width='100%'
                                                height='44px'
                                                value={`CONECTAR ${p.framework.toUpperCase()}`}
                                                imagePlus={true}
                                                outline={false}
                                                onClick={() => criarIntegracao(p.framework)}
                                            />
                                        )}
                                    </Acoes>
                                </Card>
                            ))}
                        </Grid>
                    </>
                )}
            </IntegracaoContainer>
        </>
    )
}

export default withRouter(Integracao);
